import { ROLE_IDS } from "../constants/roles.ts"

/**
 * Temporary: the client asked for the web invoice entry points to be hidden
 * from subcontractors while they decide whether subcontractors keep invoices
 * on the web app at all. The subcontractor mobile app is untouched, and the
 * data is already scoped server-side — this only removes the entry points.
 *
 * To revert, delete this module and its call sites.
 */
export const invoicesHiddenForRole = (roleId?: number | null): boolean =>
  roleId === ROLE_IDS.SUBCONTRACTOR
